// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/search-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mortgage-contacts-container {
  padding: 30px;
  font-family: "Proxima Nova", sans-serif;
  background: #F9FAFC;
}
.mortgage-contacts-container .header {
  font-size: 35px;
  color: var(--secondary-color-1);
  font-weight: 700;
}
.mortgage-contacts-container .table-filters {
  display: flex;
  justify-content: space-between;
}
.mortgage-contacts-container .table-filters input.search {
  padding-left: 60px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-position: 20px;
  background-color: white;
}
.mortgage-contacts-container .status-label {
  width: auto;
  height: 36px;
  border-radius: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
}
.mortgage-contacts-container .status-label.grey {
  font-size: 14px;
  font-weight: 700;
  color: white;
  background-color: var(--secondary-color-3);
}
.mortgage-contacts-container .status-label.green {
  font-size: 14px;
  font-weight: 700;
  color: #02B946;
  background-color: #DFF2E6;
}
.mortgage-contacts-container td > p {
  margin: 0;
  line-height: 24px;
  font-size: 14px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.mortgage-contacts-container td > p.address {
  font-size: 18px;
}
.mortgage-contacts-container .add-buyer-modal {
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background: white;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mortgage-contacts-container .add-buyer-modal.visible {
  opacity: 1;
  visibility: visible;
}
.mortgage-contacts-container .add-buyer-modal .form-section {
  height: 640px !important;
  width: 640px !important;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  border-radius: 10px;
  padding: 50px 70px;
  display: flex;
  flex-direction: column;
}
.mortgage-contacts-container .add-buyer-modal .form-section .section-title {
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
}
.mortgage-contacts-container .add-buyer-modal .form-section .section-title > span {
  font-size: 14px;
  font-weight: 600;
  color: #6C767C;
}
.mortgage-contacts-container .add-buyer-modal .form-section > button {
  height: 45px;
  font-size: 16px;
}
.mortgage-contacts-container .add-buyer-modal .form-section > button.cancel {
  background: var(--secondary-color-4);
  color: var(--secondary-color-3);
}
.mortgage-contacts-container .add-buyer-modal .form-section > button.cancel:hover {
  opacity: 0.75;
}
.mortgage-contacts-container .pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  padding: 0 15px;
}
.mortgage-contacts-container .pagination > p {
  cursor: pointer;
  font-family: "Proxima Nova", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--secondary-color-3);
  width: 80px;
}
.mortgage-contacts-container .pagination > p:hover {
  opacity: 0.75;
}
.mortgage-contacts-container .pagination > p.next {
  text-align: right;
}
.mortgage-contacts-container .pagination > ul {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
}
.mortgage-contacts-container .pagination > ul > li {
  cursor: pointer;
  margin: 0 10px;
  font-weight: 700;
  color: var(--secondary-color-3);
  font-size: 18px;
}
.mortgage-contacts-container .pagination > ul > li:hover {
  opacity: 0.75;
}
.mortgage-contacts-container .pagination > ul > li.active {
  color: var(--secondary-color-1);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/routes/MortgageDashboard/modules/MortgageContacts/contacts.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uCAAA;EACA,mBAAA;AACJ;AAAI;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;AAER;AAAI;EACI,aAAA;EACA,8BAAA;AAER;AADQ;EACI,kBAAA;EACA,6DAAA;EACA,yBAAA;EACA,uBAAA;AAGZ;AAAI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;AAER;AADQ;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,0CAAA;AAGZ;AADQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAGZ;AAAI;EACI,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAER;AADQ;EAAY,eAAA;AAIpB;AAFI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIR;AAHQ;EACI,UAAA;EACA,mBAAA;AAKZ;AAHQ;EACI,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAKZ;AAJY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAMhB;AALgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAOpB;AAJY;EACI,YAAA;EACA,eAAA;AAMhB;AALgB;EACI,oCAAA;EACA,+BAAA;AAOpB;AANoB;EAAU,aAAA;AAS9B;AAJI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAMR;AALQ;EACI,eAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;AAOZ;AANY;EAAU,aAAA;AAStB;AARY;EAAS,iBAAA;AAWrB;AATQ;EACI,aAAA;EACA,uCAAA;AAWZ;AAVY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAYhB;AAXgB;EAAU,aAAA;AAc1B;AAbgB;EACI,+BAAA;EACA,0BAAA;AAepB","sourcesContent":[".mortgage-contacts-container {\n    padding: 30px;\n    font-family: 'Proxima Nova', sans-serif;                                             \n    background: #F9FAFC;\n    .header {\n        font-size: 35px;\n        color: var(--secondary-color-1);\n        font-weight: 700;\n    }\n    .table-filters {\n        display: flex;\n        justify-content: space-between;\n        input.search {\n            padding-left: 60px;\n            background: url('../../../../assets/images/search-icon.png') no-repeat;\n            background-position: 20px;\n            background-color: white;\n        }\n    }\n    .status-label {\n        width: auto;\n        height: 36px;\n        border-radius: 5px;\n        align-items: center;\n        display: flex;\n        justify-content: center;\n        text-transform: uppercase;\n        &.grey {\n            font-size: 14px;\n            font-weight: 700;\n            color: white;\n            background-color: var(--secondary-color-3);\n        }\n        &.green {\n            font-size: 14px;\n            font-weight: 700;\n            color: #02B946;\n            background-color: #DFF2E6;\n        }\n    }\n    td > p {\n        margin: 0;\n        line-height: 24px;\n        font-size: 14px;\n        font-weight: 700;\n        color: var(--secondary-color-1);\n        &.address { font-size: 18px; }\n    }\n    .add-buyer-modal {\n        opacity: 0;\n        visibility: hidden;\n        height: 100vh;\n        width: 100vw;\n        transition: .3s ease-in-out;\n        position: fixed;\n        background: white;\n        top: 0;\n        left: 0;\n        z-index: 999;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &.visible {\n            opacity: 1;\n            visibility: visible;\n        }\n        .form-section {\n            height: 640px !important;\n            width: 640px !important;\n            background: #FFFFFF;\n            box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\n            border-radius: 10px;\n            padding: 50px 70px;\n            display: flex;\n            flex-direction: column;\n            .section-title {\n                margin: 0;\n                font-weight: 700;\n                font-size: 20px;\n                color: var(--secondary-color-1);\n                > span {\n                    font-size: 14px;\n                    font-weight: 600;\n                    color: #6C767C;\n                }\n            }\n            > button {\n                height: 45px;\n                font-size: 16px;\n                &.cancel {\n                    background: var(--secondary-color-4);\n                    color: var(--secondary-color-3);\n                    &:hover { opacity: .75; }\n                }\n            }\n        }\n    }\n    .pagination {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        height: 100px;\n        padding: 0 15px;\n        > p {\n            cursor: pointer;\n            font-family: 'Proxima Nova', sans-serif;  \n            font-size: 18px;\n            font-weight: 700;\n            color: var(--secondary-color-3);\n            width: 80px;\n            &:hover { opacity: .75; }\n            &.next { text-align: right; }\n        }\n        > ul {\n            display: flex;\n            font-family: 'Proxima Nova', sans-serif;  \n            > li { \n                cursor: pointer;\n                margin: 0 10px;\n                font-weight: 700;\n                color: var(--secondary-color-3);\n                font-size: 18px;\n                &:hover { opacity: .75; }\n                &.active {\n                    color: var(--secondary-color-1);\n                    text-decoration: underline;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
